import { render, staticRenderFns } from "./GoodDetail.vue?vue&type=template&id=1b0ee934&scoped=true&"
import script from "./GoodDetail.vue?vue&type=script&lang=js&"
export * from "./GoodDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodDetail.vue?vue&type=style&index=0&id=1b0ee934&lang=less&scoped=true&"
import style1 from "./GoodDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ee934",
  null
  
)

export default component.exports